/* eslint-disable quotes */
/* eslint-disable prettier/prettier */
import React from "react";
import styled from "styled-components";
import FooterCol from "./FooterCol";
import PText from "./PText";

const FooterStyle = styled.div`
  padding-top: 10rem;
  background-color: var(--deep-dark);
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  .para {
    p {
      text-align: justify;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">Shihab Shumon</h1>
          <PText>
            I am a front-end web developer from Dhaka,Bangladesh. I create
            professional websites. I love art and always try to show unique
            views to the audience through my website.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: "Home",
                path: "/",
                type: "Link",
              },
              {
                type: "Link",
                title: "About",
                path: "/about",
              },
              {
                type: "Link",
                title: "Projects",
                path: "/projects",
              },
              {
                type: "Link",
                title: "Contact",
                path: "/contact",
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: "+8801914608395",
                path: "tel:+8801914608395",
              },
              {
                title: "shumonshihab62@gmail.com",
                path: "mailto:shumonshihab62@gmail.com",
              },
              {
                title: "Gazipur, Dhaka, Bangladesh",
                path:
                  "https://www.google.com/maps/@24.0371764,90.289241,1130m/data=!3m1!1e3",
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Social Links"
            links={[
              {
                title: "Facebook",
                path: "https://www.facebook.com/mdshihab.shumon.3",
              },
              {
                title: "GitHub",
                path: "https://github.com/shihab91/",
              },
              {
                title: "LinkedIn",
                path: "https://www.linkedin.com/in/shihab-shumon/",
              },
              {
                title: "Twitter",
                path: "https://twitter.com/shumon_shihab",
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>© 2022 - Shihab Shumon | All rights reserved</PText>
        </div>
      </div>
    </FooterStyle>
  );
}
